import { render, staticRenderFns } from "./LabelsPieCard.vue?vue&type=template&id=6825b3cb&"
import script from "./LabelsPieCard.vue?vue&type=script&lang=js&"
export * from "./LabelsPieCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports